import { Component, Input, OnInit } from '@angular/core';
import { DocumentService } from '../../documents/document.service';
import { OrganizationService } from '../../organizations/organization.service';
import * as moment from 'moment';
import { Document, Client, Organization } from '../../shared/sdk';
import { Observable } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ClientService } from '../client.service';
import { LanguageService } from '../../shared/services/language.service';
import { map, take } from 'rxjs/operators';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-reminder-send',
  templateUrl: 'reminder-send.component.html',
})
export class ReminderSendComponent implements OnInit {
  @Input() clientId: string;
  documents$: Observable<Document[]>;
  client: Client;
  form: FormGroup;
  sent: boolean;
  org: Organization;
  totals: any[];
  language: string;

  constructor(
    private activeModal: NgbActiveModal,
    private clientService: ClientService,
    private documentService: DocumentService,
    private fb: FormBuilder,
    private languageService: LanguageService,
    private orgService: OrganizationService,
  ) {
    this.totals = [];
  }

  ngOnInit(): void {
    this.org = this.orgService._active;

    this.form = this.fb.group({
      email: ['', Validators.required],
      clientId: [this.clientId],
    });

    this.languageService
      .getCurrent()
      .pipe(take(1))
      .subscribe((l) => (this.language = l));

    this.clientService
      .get(this.org.id, { where: { id: this.clientId }, deleted: true })
      .pipe(map(({ body }) => body))
      .subscribe((clients: Client[]) => {
        this.client = clients[0];
        this.form.controls.email.patchValue(this.client.email);
      });

    this.documents$ = this.documentService
      .get(this.org.id, {
        where: {
          clientId: this.clientId,
          type: 'invoice',
          canceled: false,
          draft: false,
          paidInFull: false,
          dateDue: { lt: moment.utc().endOf('day').format('Y-MM-DD') },
          totalDue: { gt: 0 }, // no credit notes
        },
        order: 'dateDue ASC',
      })
      .pipe(
        map(({ body: documents }) => {
          documents.map((d) => {
            const idx = this.totals.findIndex(
              (t) => t.currencyId === d.currencyId,
            );

            if (idx === -1) {
              this.totals.push({
                currencyId: d.currencyId,
                amount: d.totalDue,
              });
            } else {
              this.totals[idx].amount += d.totalDue;
            }
          });

          return documents;
        }),
      );
  }

  onClose() {
    this.activeModal.dismiss();
  }

  onSave() {
    this.sent = true;

    if (this.form.valid) {
      this.activeModal.close({
        clientId: this.clientId,
        email: this.form.controls.email.value,
        l: this.language,
      });
    }
  }
}
